import { redirectToUrl } from '@wix/gg-common-lib/utils';
import { getProviderConfig } from 'config/providers';
import { biLogger } from 'hooks';

const WIX_DASHBOARD_URL = 'https://manage.wix.com/dashboard';

interface RedirectToDashboardParams {
  metaSiteId: string;
}

export function buildDashboardUrl(metaSiteId: string): string {
  const { dashboardUrl } = getProviderConfig();

  return dashboardUrl || [WIX_DASHBOARD_URL, metaSiteId].join('/');
}

export function buildDashboardPathUrl(metaSiteId: string, path: string): string {
  return [WIX_DASHBOARD_URL, metaSiteId, path.replace(/^\/+/, '')].join('/');
}

export function buildConnectDomainUrl(metaSiteId: string, domainName: string): string {
  const url = new URL(buildDashboardPathUrl(metaSiteId, 'add-domain'));
  url.searchParams.set('domainName', domainName);

  return url.toString();
}

export async function redirectToDashboard({ metaSiteId }: RedirectToDashboardParams): Promise<void> {
  if (!metaSiteId) {
    console.error('MetaSiteId is required to redirect to dashboard');
    return;
  }

  const dashboardUrl = buildDashboardUrl(metaSiteId);
  biLogger.generateSite(dashboardUrl);
  redirectToUrl(dashboardUrl);
}
